import {
  Root,
  PreviewTrip,
  PhuketLagunaVillageResidences,
  PhuketLagunaPark2,
  PhuketSkypark,
  PhuketDusitDeluxePoolVilla,
  LagunaBeachside,
  LagunaSeasideResidences,
  News,
  NewsDetail,
  SanctuaryClub,
  AboutUs,
  ContactUs,
  Home,
  NotFound,
} from "./pages";
import _ from "lodash";

export default [
  {
    component: Root,
    routes: [
      {
        key: "preview-trip",
        path: "/:language/projects/preview-trip/enquiry/",
        exact: true,
        component: PreviewTrip,
      },
      {
        key: "laguna-beachside",
        path: "/:language/projects/phuket/laguna-beachside/",
        exact: true,
        component: LagunaBeachside,
      },
      {
        key: "laguna-lakeside-residences",
        path: "/:language/projects/phuket/laguna-lakeside-residences/",
        exact: true,
        component: (props) => {
          const { match } = props;
          const lang = _.get(match, "params.language");
          const language = lang === "cn" ? "zh" : lang;
          console.log("xxxxxxxxxxxxxxxxxxxxxxxx");
          window.location.href = `https://www.lagunaproperty.com/laguna-lakeside-residences/registrationform/${language}`;
          return null;
        },
      },
      {
        key: "laguna-seaside-residences",
        path: "/:language/projects/phuket/laguna-seaside-residences/",
        exact: true,
        component: LagunaSeasideResidences,
      },
      {
        key: "phuket-laguna-village-residences",
        path: "/:language/projects/phuket/laguna-village-residences/",
        exact: true,
        component: PhuketLagunaVillageResidences,
      },
      {
        key: "phuket-laguna-park-2",
        path: "/:language/projects/phuket/laguna-park-2/",
        exact: true,
        component: PhuketLagunaPark2,
      },
      {
        key: "phuket-skypark",
        path: "/:language/projects/phuket/skypark/",
        exact: true,
        component: PhuketSkypark,
      },
      // {
      //   key: "dusit-deluxe-pool-villa",
      //   path: "/:language/projects/phuket/dusit-laguna-resort-villas-phuket/",
      //   exact: true,
      //   component: PhuketDusitDeluxePoolVilla,
      // },
      {
        key: "home",
        path: "/:language/home",
        exact: true,
        component: Home,
      },
      {
        key: "news",
        path: "/:language/news",
        exact: true,
        component: News,
      },
      {
        key: "newsDetail",
        path: "/:language/news/:newsId/:slug",
        exact: true,
        component: NewsDetail,
      },
      {
        key: "sanctuary-club",
        path: "/:language/sanctuary-club",
        exact: true,
        component: SanctuaryClub,
      },
      {
        key: "about-us",
        path: "/:language/about-us",
        exact: true,
        component: AboutUs,
      },
      {
        key: "contact-us",
        path: "/:language/contact-us",
        exact: true,
        component: ContactUs,
      },
      {
        key: "404",
        path: "*",
        exact: false,
        component: NotFound,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/routes.js